/**
 * @generated SignedSource<<61d03514e11d204c944395a092269f55>>
 * @relayHash 04b06cab5647ae39bd407575586be4c8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04b06cab5647ae39bd407575586be4c8

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteSickLeaveInput = {
  id: string;
};
export type useDeDeleteSickLeaveMutation$variables = {
  input: De_deleteSickLeaveInput;
};
export type useDeDeleteSickLeaveMutation$data = {
  readonly de_deleteSickLeave: {
    readonly de_SickLeave: {
      readonly id: string;
    } | null;
  };
};
export type useDeDeleteSickLeaveMutation = {
  response: useDeDeleteSickLeaveMutation$data;
  variables: useDeDeleteSickLeaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeDeleteSickLeaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteSickLeavePayload",
        "kind": "LinkedField",
        "name": "de_deleteSickLeave",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_SickLeave",
            "kind": "LinkedField",
            "name": "de_SickLeave",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeDeleteSickLeaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_deleteSickLeavePayload",
        "kind": "LinkedField",
        "name": "de_deleteSickLeave",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_SickLeave",
            "kind": "LinkedField",
            "name": "de_SickLeave",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "04b06cab5647ae39bd407575586be4c8",
    "metadata": {},
    "name": "useDeDeleteSickLeaveMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a21bd456864489ab54172cf75e2170e9";

export default node;
